import type { ForgeProvider } from '@/lib/api/generated/model';

/**
 * The forge's mark, in one colour (spec 163): GitLab's tanuki or GitHub's
 * octocat, drawn in `currentColor` so it takes the text's token in both themes
 * (no brand hex on our surfaces). Decorative: the host name beside it says
 * which forge.
 */
export function ForgeMark({
  provider,
  className = 'size-5',
}: {
  provider: ForgeProvider;
  className?: string;
}) {
  return (
    <svg
      viewBox="0 0 24 24"
      aria-hidden="true"
      focusable="false"
      className={className}
      fill="currentColor"
    >
      {provider === 'gitlab' ? (
        <path d="m22.7 13.3-1.2-3.6L19.2 2.6a.4.4 0 0 0-.8 0l-2.3 7.1H7.9L5.6 2.6a.4.4 0 0 0-.8 0L2.5 9.7l-1.2 3.6a.8.8 0 0 0 .3.9L12 21.8l10.4-7.6a.8.8 0 0 0 .3-.9Z" />
      ) : (
        <path d="M12 2a10 10 0 0 0-3.2 19.5c.5.1.7-.2.7-.5v-1.7c-2.8.6-3.4-1.3-3.4-1.3-.4-1.2-1.1-1.5-1.1-1.5-.9-.6.1-.6.1-.6 1 .1 1.5 1 1.5 1 .9 1.5 2.4 1.1 2.9.8.1-.7.4-1.1.6-1.3-2.2-.3-4.6-1.1-4.6-5 0-1.1.4-2 1-2.7-.1-.3-.4-1.3.1-2.7 0 0 .8-.3 2.8 1a9.6 9.6 0 0 1 5 0c1.9-1.3 2.8-1 2.8-1 .5 1.4.2 2.4.1 2.7.6.7 1 1.6 1 2.7 0 3.9-2.4 4.7-4.6 5 .4.3.7.9.7 1.9V21c0 .3.2.6.7.5A10 10 0 0 0 12 2Z" />
      )}
    </svg>
  );
}
